export { default as VerifyPhoneMessage } from './verify-phone-message';
